/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Prep_Regenerate_TitleInputs */



/**
* | output |
* | --- |
* | "Make the preparation again?" |
*
* @param {Meeting_Prep_Regenerate_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_prep_regenerate_title = /** @type {((inputs?: Meeting_Prep_Regenerate_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Prep_Regenerate_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Voorbereiding opnieuw maken?")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Refaire la préparation ?")
	return /** @type {LocalizedString} */ ("Make the preparation again?")
});